//const API_BASE_URL = 'https://your-hostinger-domain.com/api';
//const API_BASE_URL = 'http://localhost/3DMA/api';
// const API_BASE_URL = '../../api';
const API_BASE_URL = 'https://bluerock.threedma.com/api';


export const projectService = {
  // Get all companies
  getAllCompanies: async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/companies.php`);
      if (!response.ok) {
        throw new Error('Failed to fetch companies');
      }
      const companies = await response.json();
      return companies;
    } catch (error) {
      console.error('Error fetching companies:', error);
      throw error;
    }
  },

  // Get company by ID
  getCompanyById: async (companyId) => {
    try {
      const response = await fetch(`${API_BASE_URL}/companies.php?id=${companyId}`);
      if (!response.ok) {
        if (response.status === 404) {
          return null;
        }
        throw new Error('Failed to fetch company');
      }
      const company = await response.json();
      return company;
    } catch (error) {
      console.error('Error fetching company:', error);
      throw error;
    }
  },

  // Get all projects
  getAllProjects: async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/projects.php`);
      if (!response.ok) {
        throw new Error('Failed to fetch projects');
      }
      const projects = await response.json();
      return projects;
    } catch (error) {
      console.error('Error fetching projects:', error);
      throw error;
    }
  },

  // Get projects by company ID
  getProjectsByCompanyId: async (companyId) => {
    try {
      const response = await fetch(`${API_BASE_URL}/projects.php?company_id=${companyId}`);
      if (!response.ok) {
        throw new Error('Failed to fetch company projects');
      }
      const projects = await response.json();
      return projects;
    } catch (error) {
      console.error('Error fetching company projects:', error);
      throw error;
    }
  },

  // Get project by ID
  getProjectById: async (projectId) => {
    try {
      const response = await fetch(`${API_BASE_URL}/projects.php?id=${projectId}`);
      if (!response.ok) {
        if (response.status === 404) {
          return null;
        }
        throw new Error('Failed to fetch project');
      }
      const project = await response.json();
      return project;
    } catch (error) {
      console.error('Error fetching project:', error);
      throw error;
    }
  },

  // Get project descriptions
  getProjectDescriptions: async (projectId) => {
    try {
      const response = await fetch(`${API_BASE_URL}/descriptions.php?project_id=${projectId}`);
      if (!response.ok) {
        throw new Error('Failed to fetch project descriptions');
      }
      const descriptions = await response.json();
      return descriptions;
    } catch (error) {
      console.error('Error fetching project descriptions:', error);
      throw error;
    }
  },

  // Get project presentations
  getProjectPresentations: async (projectId) => {
    try {
      const response = await fetch(`${API_BASE_URL}/presentations.php?project_id=${projectId}`);
      if (!response.ok) {
        throw new Error('Failed to fetch project presentations');
      }
      const presentations = await response.json();
      return presentations;
    } catch (error) {
      console.error('Error fetching project presentations:', error);
      throw error;
    }
  }
}; 